<script>
import LoadingTemplate from "@/components/widgets/loading-template.vue";
import RawData from "@/components/widgets/raw-data.vue";
import PRAttachment from "@/router/views/procurement/pr/pr-attachment.vue"
import PrItems from "@/router/views/procurement/pr/pr-items.vue";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import PRBacResolution from "@/router/views/procurement/pr/bac-resolution.vue";
import MaskedInput from "vue-text-mask";
import { cloneDeep, groupBy, orderBy } from "lodash";
export default {
    name: "PRList",
    components: {
        LoadingTemplate,
        RawData,
        PRAttachment,
        PrItems,
        MaskedInput,
        PRBacResolution
    },
    props: {
        type: {
            type: String,
            default: 'pending',
        },
        prs: {
            type: Array,
            required: true,
        },
        loading: Boolean,
        managePR: {
            type: Boolean,
            default: false,
        },
        mop: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            filter: "",
            currentPage: 1,
            perPage: 10,
            uploadOptions: {
                type: "Purchase Request",
                placement: "lefttop",
                folder: "Procurement",
            },
            currencyMask: createNumberMask({
                prefix: "",
                includeThousandsSeparator: true,
                allowDecimal: true,
            }),
        };
    },
    computed: {
        cardTitle(){
            return this.type.charAt(0).toUpperCase() + this.type.slice(1)
        },
        isPending() {
            return this.type == "pending";
        },
        isApproved() {
            return this.type == "approved";
        },
        isSubmitted() {
            return this.type == "submitted";
        },
        isCancelled() {
            return this.type == "cancelled";
        },
        filtered() {
            let data = this.prs;
            var total = this.currentPage * this.perPage;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            data = data.slice(total - this.perPage, total);
            return data;
        },
        rows() {
            if (this.filter.trim() != "" && this.filter) {
                let data = this.prs;
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
                return data.length;
            }
            return this.prs.length;
        },
    },
    methods: {
        showDtls(row) {
            row.itemVisible = !row.itemVisible;
            if (row.itemVisible) {
                this.getPRItems(row);
            }
        },
        getPRItems(row) {
            if (!row.detailLoaded) {
                row.prItems = [];
                row.loadingDetail = true;
                this.$store
                    .dispatch("pritem/GetPrItemsSummary", row.id)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        if(res.data){
                            row.unGroupedItems = res.data.items;
                            res.data.items.forEach((item) => {
                                item.itemSort = this.moveNumbersToEnd(item.itemName.replace(/\s+/g,'').replace(/\t/g, '').replace('-', '').replace(/'/g, '').replace('–', '').replace(':', '1').replace(/[^\w\s]/gi, '').replace(/,/g, '').trim().toLowerCase());
                                item.sortDesc = this.moveNumbersToEnd(item.description.replace(/\s+/g,'').replace(/\t/g, '').replace(/[\r\n]/gm, '').replace(/'/g, '').replace('-', '').replace('–', '').replace(':', '1').replace(/[^\w\s]/gi, '').replace(/,/g, '').trim().toLowerCase());
                                item.publicRefVisible = false;
                                item.addRef = false;
                                item.refLoading = false;
                                item.refSearch = "";
                                item.publicRefs = [];
                            });
                            let groups = [];
                            var grouped = groupBy(orderBy(res.data.items, ['itemSort', 'sortDesc', 'quantity'], ['asc', 'asc', 'desc']), "itemCategoryGroup");
                            for (var key in grouped) {
                                let itemCategoryGroup = groupBy(grouped[key], "itemCategory");
                                let itemCategoryGroupArray = [];
                                let total = 0;
                                for (var key2 in itemCategoryGroup) {
                                    itemCategoryGroupArray.push({
                                        name: key2,
                                        items: itemCategoryGroup[key2],
                                    });
                                    itemCategoryGroup[key2].map((item) => {
                                        total += parseFloat(item.total);
                                    });
                                }
                                groups.push({
                                    name: key,
                                    itemCategoryGroups: itemCategoryGroupArray,
                                    total: total
                                });
                            }
                            row.prItems = groups;
                        }
                        row.detailLoaded = true;
                        row.loadingDetail = false;
                    })
                    .catch(() => {
                        this.approvedBusy = false;
                        this.showToast(
                            "Something went wrong! - getting PR Items",
                            "error"
                        );
                    });
            }
        },
        updateResource(data, type, pr){
            this.$emit('updateResource', {data, type, pr});
        },
        getAttachments(row) {
            row.attachmentVisible = !row.attachmentVisible;
            if (row.attachmentVisible) {
                row.prFiles = [];
                row.fileSearch = "";
                row.attachmentLoading = true;
                this.$store
                    .dispatch("filemanager/GetFiles", {
                        id: row.id,
                        type: this.uploadOptions.type,
                    })
                    .then((res) => {
                        row.attachmentLoading = false;
                        row.prFiles = res.data;
                    })
                    .catch(() => {
                        row.attachmentLoading = false;
                        this.showToast(
                            "Something went wrong! - getting documents",
                            "error"
                        );
                    });
            }
        },
        printPR(id) {
            this.$emit('printPR', id);
        },
        changePRNo(row){
            this.$emit('changePRNo', row);
        },
        moveToCampus(row){
            this.$emit('moveToCampus', row);
        },
        updateCycle(row, type){
            this.$emit('updateCycle', {row, type});
        },
        updatePRDescription(row, type){
            this.$emit('updatePRDescription', {row, type});
        },
        getPRLogs(id) {
            this.$emit('getPRLogs', id);
        },
        returnPR(row){
            this.$emit('returnPR', row);
        },
        returnToPending(row){
            let index = this.prs.findIndex(x => x.id == row.id);
            this.$swal.fire({
                title: "Are you sure?",
                text: "You want to return this PR to pending?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, return it!",
            }).then(async (result) => {
                if(!result.value){
                    return;
                }
                await this.$store.dispatch('pr/ReturnToPending', row.id).then(res => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error')
                    }
                    if(index > -1){
                        this.prs.splice(index, 1);
                    }
                    row.showDetails = false;
                    this.$emit('returnedToPending', row);
                    this.showToast('Successfully returned to pending', 'success')
                })
                .catch(err => {
                    this.showToast('Something went wrong!', 'error')
                })
            });
        },
        approvePR(row) {
            this.$emit('approvePR', row);
        },
        uploaded(response, row) {
            row.prFiles.push(response);
        },
        removeFile(id, parentId) {
            this.$swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("filemanager/DeleteFile", id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "error"
                                );
                            }
                            let pIndex = this.prs.findIndex((x) => x.id == parentId);
                            if (pIndex > -1) {
                                let fIndex = this.prs[pIndex].prFiles.findIndex(
                                    (x) => x.id == id
                                );
                                if (fIndex > -1) {
                                    this.prs[pIndex].prFiles.splice(fIndex, 1);
                                }
                            }
                            this.showToast("Successfully removed!", "success");
                        })
                        .catch(() => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        needAction(row){
            let sum = 0;
            if(!row.modeOfProcurementId || row.modeOfProcurementId == 0){
                sum++;
            }
            if(!row.deliveryTerms || row.deliveryTerms === ''){
                sum++;
            }
            if(!row.deliveryPeriod || row.deliveryPeriod === ''){
                sum++;
            }
            if(!row.deliveryLocation || row.deliveryLocation === ''){
                sum++;
            }
            if(!row.paymentTerms || row.paymentTerms === ''){
                sum++;
            }
            if(!row.endUser || row.endUser === ''){
                sum++;
            }
            if(!row.endUserPosition || row.endUser === ''){
                sum++;
            }
            return sum;
        },
        ifPB(pr){
            let modePr = this.mop.find(x => x.id == pr.modeOfProcurementId);
            if(modePr && modePr.name.toLowerCase().includes('public bidding')){
                return true;
            }
            return false;
        },
        async getPrResolutions(x){
            x.memberVisible = !x.memberVisible
            if(x.memberVisible && x.prResolutions.length == 0){
                x.prResolutionLoading = true;
                await this.$store.dispatch('prresolution/GetPRResolution', x.id).then(res => {
                    res.data.map(item => {
                        item.memberLoading = false;
                        item.prResolutionMembers = [];
                        item.bacResAntiDate = item.bacResDate ? new Date(item.bacResDate) : null;
                    })
                    x.prResolutions = res.data;
                    if(x.prResolutions.length > 0){
                        this.getPrResolutionMembers(x.prResolutions[0]);
                    }
                })
                .catch(err => {
                    this.showToast('Something went wrong!', 'error')
                })
                x.prResolutionLoading = false;
            }
        },
        async getPrResolutionMembers(row){
            if(row.prResolutionMembers.length == 0){
                row.memberLoading = true;
                await this.$store.dispatch('prresolutionmember/GetResolutionMembers', row.id).then(res => {
                    row.prResolutionMembers = res.data;
                })
                .catch(err => {
                    this.showToast('Something went wrong!', 'error')
                })
                row.memberLoading = false;   
            }
        },
        getAttachmentBacRes(id){
            this.$emit('getAttachmentBacRes', id);
        },
        printBacRes(id){
            this.$emit('printBacRes', id);
        },
        async saveBACResDetail(row){
            let data = cloneDeep(row);
            data.bacResDate = this.getDate(data.bacResAntiDate);
            await this.$store.dispatch('prresolution/UpdatePRResolution', data).then(res => {
                this.showToast('BAC Resolution updated!', 'success')
            })
            .catch(err => {
                this.showToast('Something went wrong!', 'error')
            })
        },
        updateBACMember(data){
            this.$emit('updateBACMember', data);
        },
        deleteBACMember({row, parent}){
            this.$swal.fire({
                title: "Are you sure?",
                text: "You want to delete this member?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("prresolutionmember/RemoveBACMember", row.id)
                        .then(async (res) => {
                            let index = parent.prResolutionMembers.findIndex(x => x.id == row.id);
                            parent.prResolutionMembers.splice(index, 1);
                            this.showToast("BAC member deleted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong! - deleting BAC member", "error");
                        });
                }
            })
            .catch((err) => {
                this.showToast("Something went wrong! - removing BAC member", "error");
            });
        },
        submitToRFQ(row){
            this.$emit('submitToRFQ', row);
        },
        showForms(row){
            row.detailVisible = !row.detailVisible;
        },
        async updateDetail(row){
            row.submitDetail = true;
            if(!row.modeOfProcurementId){
                return;
            }
            let data = {
                id: row.id,
                modeOfProcurementId: row.modeOfProcurementId,
                bacResNumber: row.bacResNumber,
                deliveryTerms: row.deliveryTerms,
                deliveryPeriod: row.deliveryPeriodStr ? this.getExactAmt(row.deliveryPeriodStr) : '0',
                deliveryLocation: row.deliveryLocation,
                paymentTerms: row.paymentTerms,
                endUserId: row.endUserId,
                bacResDate: this.getDate(row.bacResAntiDate),
                isEarlyProcurement: row.isEarlyProcurement,
                modeOfProcurementCategory: row.modeOfProcurementCategory,
                technicalUserId: row.technicalUserId,
                // endUser: row.endUser,
                // endUserPosition: row.endUserPosition,
            }
            await this.$store.dispatch('pr/UpdatePrDetails', data)
            .then(res => {
                if (res.data.error) {
                    return this.showToast(
                        res.data.errorMessage,
                        "error"
                    );
                }
                this.showToast('Successfully updated!', 'success');
            })
            .catch(err => {
                this.showToast('Something went wrong!', 'error');
            })
            row.submitDetail = false;
        },
        selectUser(x, type){
            this.$emit('selectUser', {x, type});
        },
        cancelPR(row){
            this.$emit('cancelPR', row);
        },
        removePRItem({data, parent}){
            this.$swal.fire({
                title: "Are you sure?",
                text: "You want to delete this PR item?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await this.$store.dispatch('pritem/DeletePrItem', data.id)
                        .then(res => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = parent.items.findIndex(x => x.id == data.id);
                            parent.items.splice(index, 1);
                            this.showToast('Successfully removed!', 'success');
                        })
                        .catch(err => {
                            console.log(err);
                            this.showToast('Something went wrong!', 'error');
                        })
                }
            });

        }
    },
};
</script>
<template>
    <div class="card">
        <div 
            class="card-body bg-soft" 
            :class="{
                'bg-info': isPending,
                'bg-primary': isApproved,
                'bg-success': isSubmitted,
                'bg-warning': isCancelled,
            }"
        >
            <div class="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h4 class="card-title mb-0"> {{cardTitle}} Purchase Request <span v-if="isSubmitted">to Bids/RFQ</span></h4>
                    <p class="card-title-desc mb-0"> List of {{type}} Purchase Request <span v-if="isSubmitted">to Bids/RFQ</span></p>
                </div>
                <div v-if="prs.length">
                    <input
                        autocomplete="off"
                        id="name"
                        type="text"
                        v-model="filter"
                        placeholder="Search P.R..."
                        class="form-control"
                    />
                </div>
            </div>
            <div
                v-if="!loading && !prs.length"
                class="text-center"
            >
                <h5>No data available</h5>
            </div>
            <LoadingTemplate v-if="loading" />
            <div
                v-if="!loading && filter && !filtered.length"
                class="text-center"
            >
                <h5>Search not found</h5>
            </div>
            <template v-if="!loading && prs.length">
                <div
                    role="tablist"
                    v-for="x in filtered"
                    :key="x.id"
                >
                    <b-card
                        no-body
                        class="mb-1 shadow-none"
                    >
                        <RawData 
                            :data="x" 
                            v-if="$store.state.decrypt.isAdmin()" 
                            placement="left"
                        />
                        <b-card-header
                            header-tag="header"
                            role="tab"
                            header-class="cursor-pointer"
                            @click="x.showDetails = !x.showDetails"
                        >
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <h6 class="mb-1">
                                        <a
                                            class="text-dark"
                                            href="javascript: void(0);"
                                        >
                                            [{{x.prNumber}}]:&nbsp;{{x.description}}
                                        </a>
                                        <a href="javascript:void(0);" class="bx bx-edit font-size-16 me-1" title="Edit Description" @click.stop="updatePRDescription(x, type)" v-if="managePR && !isCancelled"></a>
                                        <a href="javascript:void(0);" class="bx bx-transfer font-size-16 text-info" title="Transfer to Another Cycle" @click.stop="updateCycle(x, type)" v-if="managePR && !isCancelled"></a>
                                        <a href="javascript:void(0);" class="bx bx-link font-size-16 text-green" title="Change PR Number" @click.stop="changePRNo(x)" v-if="$store.state.decrypt.isAdmin()"></a>
                                        <a href="javascript:void(0);" class="bx bx-building font-size-16 text-orange" title="Move to another Campus" @click.stop="moveToCampus(x)"></a>
                                    </h6>
                                    <span v-if="!x.type">
                                        <small>{{ x.deliveryUnit }}
                                            <span  v-if="x.departmentName"> | <span class="text-yellow">{{x.departmentName}}</span></span>
                                        </small>
                                    </span>
                                    <small v-else class="text-warning">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} PR</small>
                                </div>
                                <div class="d-flex align-items-center">
                                    <div>
                                        <span 
                                            class="d-flex align-items-center"
                                        >
                                            <small v-if="!x.showDetails">Click here to expand</small>
                                            <i 
                                                class="bx bx-chevron-right rotate font-size-18 ms-3"
                                                :class="{'rotate-90': x.showDetails}"
                                            ></i
                                        ></span>
                                    </div>
                                </div>
                            </div>
                        </b-card-header>
                        <b-collapse
                            :visible="x.showDetails"
                            :accordion="`pending-accordion-${x.id}`"
                            role="tabpanel"
                        >
                            <b-card-body class="border">
                                <template v-if="!isPending">
                                    <div
                                        class="
                                            d-flex
                                            align-items-center
                                            justify-content-between
                                            cursor-pointer
                                        "
                                        @click="showForms(x)"
                                    >
                                        <div>
                                            <h5 class="mb-0 text-info">
                                                <i
                                                    class="
                                                        bx bx-receipt

                                                    "
                                                ></i>
                                                Purchase Request
                                                Details
                                            </h5>
                                            <small v-if="needAction(x) > 0" class="text-warning">{{needAction(x)}} inputs needs an action</small>
                                        </div>
                                        <h5 class="mb-0">
                                            <i
                                                class="
                                                    bx
                                                    bx-chevron-right
                                                    rotate
                                                "
                                                :class="{
                                                    'rotate-90':
                                                        x.detailVisible,
                                                }"
                                            ></i>
                                        </h5>
                                    </div>
                                    <b-collapse
                                        :visible="x.detailVisible"
                                        :accordion="`item-detail-accordion-${x.id}`"
                                        role="tabpanel"
                                    >
                                        <hr />
                                        <div class="d-flex flex-row-reverse mb-2">
                                            <div
                                                class="
                                                    form-check
                                                    form-checkbox-outline
                                                    form-check-success
                                                "
                                            >
                                                <input
                                                    type="checkbox"
                                                    :id="`pr-item-${x.id}`"
                                                    checked="checked"
                                                    class="form-check-input"
                                                    v-model="x.isEarlyProcurement"
                                                    :disabled="isCancelled"
                                                /><label
                                                    :for="`pr-item-${x.id}`"
                                                    class="form-check-label"
                                                >
                                                    Early Procurement
                                                </label>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3 mb-2">
                                                <label for="">Mode of Procurement</label>
                                                <select 
                                                    class="form-select" 
                                                    v-model="x.modeOfProcurementId" 
                                                    :class="{'border-danger': x.submitDetail && !x.modeOfProcurementId}"
                                                    :disabled="isCancelled"
                                                >
                                                    <option></option>
                                                    <option v-for="y in mop" :key="y.id" :value="y.id">{{y.name}}</option>
                                                </select>
                                            </div>
                                            <div class="col-md-3" v-if="ifPB(x)">
                                                <label for="">Bidding Category</label>
                                                <select 
                                                    class="form-select" 
                                                    v-model="x.modeOfProcurementCategory" 
                                                    :class="{'border-danger': x.submitDetail && !x.modeOfProcurementCategory}"
                                                    :disabled="isCancelled"
                                                >
                                                    <option></option>
                                                    <option v-for="y in ['Goods/Services', 'Infrastructure', 'Consultancy']" :key="y" :value="y">{{y}}</option>
                                                </select>
                                            </div>
                                            <div class="col-md-3" v-if="ifPB(x)">
                                                <label for="">Technical Working Group</label>
                                                <b-input-group>
                                                    <template
                                                        #append
                                                    >
                                                        <b-button
                                                            @click="selectUser(x, 'technicalUser')"
                                                            v-if="managePR && !isCancelled"
                                                            variant="outline-info"
                                                        >
                                                            <i class="mdi mdi-clipboard-text-search-outline"></i>
                                                        </b-button>
                                                    </template>
                                                    <input type="text" class="form-control" v-model="x.technicalUser" disabled>
                                                </b-input-group>
                                            </div>
                                            <div class="col-md-3">
                                                <label for="">Delivery Terms</label>
                                                <input type="text" class="form-control" v-model="x.deliveryTerms" :disabled="isCancelled">
                                            </div>
                                            <div class="col-md-3 mb-2">
                                                <label for="">Delivery Period</label>
                                                <!-- <input type="text" class="form-control" v-model="x.deliveryPeriod"> -->
                                                <b-input-group>
                                                    <masked-input
                                                        style="width: 80px"
                                                        id="deliveryPeriod"
                                                        type="text"
                                                        v-model="x.deliveryPeriodStr"
                                                        placeholder="Enter Delivery Period..."
                                                        class="form-control"
                                                        :mask="currencyMask"
                                                        autocomplete="off"
                                                        :disabled="isCancelled"
                                                    ></masked-input>
                                                    <div class="input-group-append" style="width:calc(100% - 80px)">
                                                        <span class="form-control">calendar day(s)</span>
                                                    </div>
                                                </b-input-group>
                                            </div>
                                            <div class="col-md-3 mb-2">
                                                <label for="">Delivery Location</label>
                                                <input type="text" class="form-control" v-model="x.deliveryLocation" :disabled="isCancelled">
                                            </div>
                                            <div class="col-md-3">
                                                <label for="">Payment Terms</label>
                                                <select
                                                    v-model="x.paymentTerms"
                                                    class="form-select"
                                                    :disabled="isCancelled"
                                                >
                                                    <option value=""></option>
                                                    <option value="Send Bill">
                                                        Send Bill
                                                    </option>
                                                    <option value="DR">DR</option>
                                                    <option value="Monthly Billing">
                                                        Monthly Billing
                                                    </option>
                                                    <option
                                                        value="One Time Payment"
                                                    >
                                                        One Time Payment
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-md-3">
                                                <label for="">End User</label>
                                                <b-input-group>
                                                    <template
                                                        #append
                                                    >
                                                        <b-button
                                                            @click="selectUser(x, 'endUser')"
                                                            v-if="managePR && !isCancelled"
                                                            variant="outline-info"
                                                            ><i
                                                                class="
                                                                    mdi
                                                                    mdi-clipboard-text-search-outline
                                                                "
                                                            ></i
                                                        ></b-button>
                                                    </template>
                                                    <input type="text" class="form-control" v-model="x.endUser" disabled>
                                                </b-input-group>
                                            </div>
                                            <div class="col-md-3 mb-3">
                                                <label for="">End User Position</label>
                                                <input type="text" class="form-control" v-model="x.endUserPosition" disabled>
                                            </div>
                                            <div class="col-md-3 mb-3" v-if="managePR && !isCancelled">
                                                <label for="">Action:</label>
                                                <div class="d-flex align-items-center flex-row-reverse">
                                                    <button type="button" class="btn btn-link w-50" @click="showForms(x)"><i class="bx bx-x me-1"></i>Cancel</button>
                                                    <button type="button" class="btn btn-success me-1 w-50" @click="updateDetail(x)"><i class="bx bx-save me-1"></i>Update Detail</button>
                                                </div>
                                            </div>
                                        </div>
                                    </b-collapse>
                                    <hr />
                                </template>
                                <div
                                    class="
                                        d-flex
                                        align-items-center
                                        justify-content-between
                                        cursor-pointer
                                    "
                                    @click="showDtls(x)"
                                >
                                    <h5 class="mb-0 text-green">
                                        <i
                                            class="
                                                bx
                                                bx-menu-alt-right
                                            "
                                        ></i>
                                        Purchase Request Items
                                    </h5>
                                    <h5 class="mb-0">
                                        <i
                                            class="
                                                bx
                                                bx-chevron-right
                                                rotate
                                            "
                                            :class="{
                                                'rotate-90':
                                                    x.itemVisible,
                                            }"
                                        ></i>
                                    </h5>
                                </div>
                                <b-collapse
                                    :visible="x.itemVisible"
                                    :accordion="`pending-item-accordion-${x.id}`"
                                    role="tabpanel"
                                >
                                    <hr />
                                    <LoadingTemplate v-if="x.loadingDetail" />
                                    <div
                                        v-if="
                                            !x.loadingDetail &&
                                            x.prItems
                                                .length == 0
                                        "
                                        class="text-center"
                                    >
                                        No items found
                                    </div>
                                    <template v-if="!x.loadingDetail && x.prItems.length > 0">
                                        <PrItems :pr="x" @updateResource="updateResource($event, type, x)" @removeResource="removePRItem" :isCancelled="isCancelled"/>
                                    </template>
                                </b-collapse>
                                <hr />
                                <template v-if="!isPending">
                                    <div
                                        class="d-flex align-items-center justify-content-between cursor-pointer"
                                        @click="getPrResolutions(x)"
                                    >
                                        <div>
                                            <h5 class="mb-0 text-primary d-flex align-items-center">
                                                <i class="bx bx-user-check font-size-18 me-1"></i>
                                                BAC Resolution
                                            </h5>
                                        </div>
                                        <h5 class="mb-0">
                                            <i
                                                class="bx bx-chevron-right rotate"
                                                :class="{ 'rotate-90': x.memberVisible }"
                                            ></i>
                                        </h5>
                                    </div>
                                    <b-collapse
                                        :visible="x.memberVisible"
                                        :accordion="`approved-member-accordion-${x.id}`"
                                        role="tabpanel"
                                    >
                                        <hr />
                                        <template v-if="!x.prResolutionLoading && x.prResolutions.length == 0">
                                            <h4 class="text-center">No data found...</h4>
                                        </template>
                                        <template v-if="x.prResolutionLoading">
                                            <LoadingTemplate />
                                        </template>
                                        <template v-if="!x.prResolutionLoading && x.prResolutions.length > 0">
                                            <PRBacResolution 
                                                :managePR="managePR" 
                                                :pr="x" 
                                                :isCancelled="isCancelled"
                                                @getPrResolutionMembers="getPrResolutionMembers"
                                                @getAttachmentBacRes="getAttachmentBacRes"
                                                @saveBACResDetail="saveBACResDetail"
                                                @printBacRes="printBacRes"
                                                @updateBACMember="updateBACMember"
                                                @deleteBACMember="deleteBACMember"
                                            />
                                        </template>
                                    </b-collapse>
                                    <hr />
                                </template>
                                <div
                                    class="d-flex align-items-center justify-content-between cursor-pointer"
                                    @click="getAttachments(x)"
                                >
                                    <h5 class="mb-0 text-warning">
                                        <i class="bx bx-paperclip rotate rotate-90"></i>
                                        Attachments
                                    </h5>
                                    <h5 class="mb-0">
                                        <i class="bx bx-chevron-right rotate" :class="{ 'rotate-90': x.attachmentVisible }"></i>
                                    </h5>
                                </div>
                                <PRAttachment 
                                    :prId="x.id"
                                    :visible="x.attachmentVisible"
                                    :prFiles="x.prFiles"
                                    :managePR="managePR"
                                    @uploaded="uploaded($event, x)"
                                    @removeFile="removeFile($event, x.id, type)"
                                />
                                <hr />
                                <div class="row">
                                    <div class="col-md-6">
                                        <button
                                            type="button"
                                            class="btn btn-purple me-2"
                                            @click="printPR(x.id)"
                                        >
                                            <i class="bx bx-printer me-1"></i>
                                            Print PR
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-warning me-2"
                                            @click="returnPR(x)"
                                            v-if="managePR && isPending"
                                        >
                                            <i class="bx bx-revision me-1"></i>
                                            Return Purchase Request
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-warning me-2"
                                            @click="returnToPending(x)"
                                            v-if="managePR && (isApproved || (isSubmitted && $store.state.decrypt.isAdmin()) || isCancelled)"
                                        >
                                            <i class="bx bx-revision me-1"></i>
                                            Return PR to Pending
                                        </button>
                                        <button type="button" class="btn btn-danger me-2" @click="cancelPR(x)" v-if="managePR && !isCancelled && !isPending">
                                            <i class="bx bx-x me-1"></i>Cancel PR
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-info me-2"
                                            @click="getPRLogs(x.id)"
                                        >
                                            <i class="bx bxs-receipt me-1"></i>
                                            PR Logs
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-success me-2"
                                            @click="approvePR(x)"
                                            v-if="managePR && isPending"
                                        >
                                            <i class="bx bx-check me-1"></i>
                                            Approve Purchase Request
                                        </button>
                                        <button type="button" class="btn btn-success" @click="submitToRFQ(x)"  v-if="managePR && isApproved">
                                            <i class="bx bx-check me-1"></i>Submit to Bids/RFQ
                                        </button>
                                    </div>
                                </div>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </template>
            <div class="mt-4" v-if="prs.length">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                        ></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>